import React, { useState } from 'react';
import { Users, Mail, Send, Briefcase } from 'lucide-react';
import InternshipForm from './InternshipForm';
import NewsletterForm from './NewsletterForm';

const SignupSection = () => {
  const [internshipFormOpen, setInternshipFormOpen] = useState(false);
  const [newsletterFormOpen, setNewsletterFormOpen] = useState(false);

  return (
    <>
      <InternshipForm isOpen={internshipFormOpen} onClose={() => setInternshipFormOpen(false)} />
      <NewsletterForm isOpen={newsletterFormOpen} onClose={() => setNewsletterFormOpen(false)} />
      
      <section className="py-20 bg-gradient-to-b from-black to-purple-950/20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Join Our <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Community</span>
            </h2>
            <p className="text-gray-400 text-lg">
              Stay connected and grow with High Quality Studios
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Internship Card */}
            <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 backdrop-blur-sm border border-purple-500/20 rounded-xl p-8 hover:border-purple-500/50 transition-all">
              <div className="w-16 h-16 bg-purple-600/20 rounded-full flex items-center justify-center mb-6 border border-purple-500/30">
                <Briefcase className="text-purple-400" size={32} />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3">
                Internship Program
              </h3>
              <p className="text-gray-400 mb-6">
                Gain hands-on experience in professional music production, engineering, and studio operations. Learn from industry professionals.
              </p>
              
              <ul className="space-y-2 mb-6 text-gray-300 text-sm">
                <li className="flex items-center">
                  <span className="text-purple-400 mr-2">✓</span>
                  Work with professional equipment
                </li>
                <li className="flex items-center">
                  <span className="text-purple-400 mr-2">✓</span>
                  Learn recording & mixing techniques
                </li>
                <li className="flex items-center">
                  <span className="text-purple-400 mr-2">✓</span>
                  Mentorship from experienced engineers
                </li>
                <li className="flex items-center">
                  <span className="text-purple-400 mr-2">✓</span>
                  Build your portfolio
                </li>
              </ul>

              <button
                onClick={() => setInternshipFormOpen(true)}
                className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-all flex items-center justify-center space-x-2 hover:scale-105"
              >
                <Send size={20} />
                <span>Apply Now</span>
              </button>
            </div>

            {/* Newsletter Card */}
            <div className="bg-gradient-to-br from-blue-900/30 to-purple-900/30 backdrop-blur-sm border border-blue-500/20 rounded-xl p-8 hover:border-blue-500/50 transition-all">
              <div className="w-16 h-16 bg-blue-600/20 rounded-full flex items-center justify-center mb-6 border border-blue-500/30">
                <Mail className="text-blue-400" size={32} />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3">
                Newsletter & Updates
              </h3>
              <p className="text-gray-400 mb-6">
                Get exclusive promotions, studio news, early access to new services, and special offers delivered to your inbox.
              </p>
              
              <ul className="space-y-2 mb-6 text-gray-300 text-sm">
                <li className="flex items-center">
                  <span className="text-blue-400 mr-2">✓</span>
                  Exclusive discounts & promotions
                </li>
                <li className="flex items-center">
                  <span className="text-blue-400 mr-2">✓</span>
                  Studio updates & new services
                </li>
                <li className="flex items-center">
                  <span className="text-blue-400 mr-2">✓</span>
                  Early booking access
                </li>
                <li className="flex items-center">
                  <span className="text-blue-400 mr-2">✓</span>
                  No spam, unsubscribe anytime
                </li>
              </ul>

              <button
                onClick={() => setNewsletterFormOpen(true)}
                className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all flex items-center justify-center space-x-2 hover:scale-105"
              >
                <Mail size={20} />
                <span>Subscribe Now</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignupSection;
